import Vue from 'vue'
import { isEmpty, clone } from 'ramda'

export default {
  methods: {
    addNewElementTranslationInfoObject({
      translationInfo,
      key,
      elementToBeAdded,
      translationsProperty,
      newChildElementToBeAdded,
    }) {
      if (typeof translationInfo === 'undefined' || isEmpty(translationInfo.AvailableCultures))
        return
      translationInfo.AvailableCultures?.forEach(function(availableCulture) {
        if (typeof newChildElementToBeAdded !== 'undefined') {
          Vue.set(
            translationInfo.Translations[availableCulture.Name][translationsProperty][key][
              newChildElementToBeAdded.childKeyName
            ],
            'new-' + (newChildElementToBeAdded.key + 1),
            clone(elementToBeAdded),
          )
        } else {
          translationInfo.Translations[availableCulture.Name][translationsProperty] =
            translationInfo.Translations[availableCulture.Name][translationsProperty] === null
              ? {}
              : translationInfo.Translations[availableCulture.Name][translationsProperty]

          Vue.set(
            translationInfo.Translations[availableCulture.Name][translationsProperty],
            'new-' + (key + 1),
            clone(elementToBeAdded),
          )
        }
      })
    },
    removeElementTranslationInfoObject({
      self,
      translationInfo,
      key,
      translationsProperty,
      childElementToBeRemoved,
    }) {
      if (typeof translationInfo === 'undefined' || isEmpty(translationInfo.AvailableCultures))
        return false
      translationInfo.AvailableCultures.forEach(function(availableCulture) {
        typeof childElementToBeRemoved !== 'undefined'
          ? self.$delete(
              translationInfo.Translations[availableCulture.Name][translationsProperty][key][
                childElementToBeRemoved.childKeyName
              ],
              childElementToBeRemoved.key,
            )
          : self.$delete(
              translationInfo.Translations[availableCulture.Name][translationsProperty],
              key,
            )
      })
    },
  },
}
